import React, { useState } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { auth, createUserDocument } from "../firebase.config";
import { AuthErrorCodes, createUserWithEmailAndPassword } from "firebase/auth";

export default function SignUp() {
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [infoError, setInfoError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const handleSignUp = async (e) => {
    if (!fullName || !companyName || !email || !password) {
      setInfoError(true);
      alert("Please fill in all the required fields.");
      return false;
    } else if (!password.length >= 6) {
      alert("Password must be at least 6 characters long.");
      return false;
    }
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      alert("User Account is Created");
      await createUserDocument(user, {
        fullName,
        companyName,
        password,
        reportInfo: {
          companyAddress: "",
          companyEmail: "",
          companyPhoneNo: "",
          disclaimerTermsCondition: "",
        },
      });
      window.location.pathname = "/pristinepvSignIn";
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        alert("Email is already in use. Please try another email.");
      } else if (error.code === "auth/invalid-email") {
        alert("Invalid-Email");
      } else if (error.code === AuthErrorCodes.WEAK_PASSWORD) {
        alert("Your Password does not match Standard");
      } else if (error.code === "auth/weak-password") {
        alert("Password must be at least 6 characters long.");
      } else {
        alert(error.message);
      }
    }
  };

  return (
    <div className="signContainer">
      <div className="logInBox">
        <img src="../images/pristinePvLogo.jpg" alt="Logo"></img>
        <div className="loginFrame">
          <h1>Create Account</h1>
          <form>
            <label>Full Name</label>
            <input
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            ></input>
            {!fullName && infoError && <span>This field is mandatory</span>}
            <label>Company Name</label>
            <input
              type="text"
              placeholder="Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            ></input>
            {!companyName && infoError && <span>This field is mandatory</span>}
            <label>Email ID</label>
            <input
              type="email"
              placeholder="e.g: email@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            ></input>
            {!email && infoError && <span>This field is mandatory</span>}
            <label>Password</label>
            <div className="passwordInput">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></input>
              <i
                className={
                  showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                }
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>
            {!password && infoError && <span>This field is mandatory</span>}
          </form>
          <div className="loginButton">
            <button onClick={handleSignUp}>Sign Up</button>

            <div className="otherLinks">
              <h6>Already have an account?</h6> <Link to="/pristinepvSignIn">Login</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
